import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Compte créé avec succès !");
      navigate("/espace-client");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <section className="min-h-[80vh] flex items-center py-20">
      <div className="mx-auto max-w-lg w-full px-6">
        <div className="text-center mb-10">
          <div className="h-14 w-14 rounded-2xl bg-[#2196F3] flex items-center justify-center mx-auto mb-6">
            <UserPlus className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-display text-4xl font-extrabold text-slate-900">Créer un compte</h1>
          <p className="text-slate-600 mt-2">Suivez vos devis et vos interventions dans votre espace client.</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 space-y-5" data-testid="register-form">
          <div className="space-y-2">
            <Label htmlFor="rname">Nom complet *</Label>
            <Input id="rname" required value={form.name} onChange={set("name")} className="h-12" data-testid="register-name" />
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="remail">Email *</Label>
              <Input id="remail" type="email" required value={form.email} onChange={set("email")} className="h-12" data-testid="register-email" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="rphone">Téléphone</Label>
              <Input id="rphone" value={form.phone} onChange={set("phone")} className="h-12" data-testid="register-phone" />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="rcompany">Société</Label>
            <Input id="rcompany" value={form.company} onChange={set("company")} className="h-12" data-testid="register-company" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="rpwd">Mot de passe * (6 caractères min.)</Label>
            <Input id="rpwd" type="password" required minLength={6} value={form.password} onChange={set("password")} className="h-12" data-testid="register-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-[#2196F3] hover:bg-[#1976D2] text-white h-12" data-testid="register-submit">
            {loading ? "Création…" : "Créer mon compte"}
          </Button>
          <div className="text-center text-sm text-slate-500 pt-2">
            Déjà inscrit ?{" "}
            <Link to="/connexion" className="text-[#2196F3] hover:text-[#1976D2] font-semibold">Se connecter</Link>
          </div>
        </form>
      </div>
    </section>
  );
}
